const { format: formatDate, addMonths, endOfMonth, } = require('date-fns');
const { range, isFunction, } = require('lodash');
const numeral = require('numeral');

const fieldDisplayValue = (values, key, { type, options: _options, }) => {
  const v = values[key];
  const options = isFunction(_options) ? _options(values) : _options;
  return (({
    select: _ => (options.find(_ => _.value === v) || {}).label,
    multiSelect: _ => (v || []).map(v => (options.find(_ => _.value === v) || {}).label).join(', '),
    date: _ => v && formatDate(v.toDate(), 'yyyy/MM/dd'),
    datetime: _ => v && formatDate(v.toDate(), 'yyyy/MM/dd HH:mm'),
    boolean: _ => ({ true: 'はい', false: 'いいえ' })[v || false],
  })[type] || (_ => v))();
};

const unslash = _ => _?.replace(/\//g, '%%slash%%');
const slash = _ => _?.replace(/%%slash%%/g, '/');
const safeFormatDate = (date, ...args) => date && formatDate(date, ...args);

const serial = async (xs, f) => {
  return await xs.reduce(async (_, x, i) => {
    return [...(await _), await f(x, i)];
  }, Promise.resolve([]));
};

const { generalTaxRate } = require('./config');

const excludeTax = (value, rate) => Math.round(value / (1 + (rate ?? generalTaxRate)));
const includeTax = (value, rate) => Math.round(value * (1 + (rate ?? generalTaxRate)));

exports.excludeTax = excludeTax;
exports.includeTax = includeTax;
exports.fieldDisplayValue = fieldDisplayValue;
exports.unslash = unslash;
exports.slash = slash;
exports.safeFormatDate = safeFormatDate;
exports.serial = serial;
